import { CatButton } from '@blocks-react/components/Button';
import { ViewReplacementBtnProps } from '../types';

export const ViewReplacementBtn = ({
  children,
  onClick,
  ...buttonProps
}: ViewReplacementBtnProps) => {
  return (
    <CatButton
      variant="contrast"
      size="sm"
      fullWidth
      onClick={onClick}
      data-track-event="e_primaryCTA"
      data-track-attr-nltext="View Replacement"
      {...buttonProps}
    >
      {children}
    </CatButton>
  );
};
